import { Checkbox, Input } from 'antd';
import { useState } from 'react';

interface Option {
	value: string;
	label: string;
}

interface Props {
	value: string[];
	options: Option[];
	onChange: (checkedValues: string[]) => void;
	searchable?: boolean;
	searchPlaceholder?: string;
	/** If true, options are hidden (e.g. waiting for a dependency to be selected) */
	disabled?: boolean;
	disabledMessage?: string;
	/** Compact mode for tablet/horizontal layouts */
	compact?: boolean;
	/** Show a Select All / Deselect All toggle */
	showSelectAll?: boolean;
	selectAllLabel?: string;
	deselectAllLabel?: string;
	extraHeader?: React.ReactNode;
}

export const CheckboxFilter = ({
	value,
	options,
	onChange,
	searchable = false,
	searchPlaceholder = 'Search...',
	disabled = false,
	disabledMessage,
	compact = false,
	extraHeader,
}: Props) => {
	const [search, setSearch] = useState('');

	const filteredOptions = searchable
		? options.filter((o) =>
				o.label.toLowerCase().includes(search.toLowerCase())
		  )
		: options;

	if (compact) {
		return (
			<div>
				{searchable && (
					<Input
						size="small"
						placeholder={searchPlaceholder}
						value={search}
						onChange={(e) => setSearch(e.target.value)}
						allowClear
						style={{ marginBottom: 4, width: 160 }}
					/>
				)}
				{disabled && disabledMessage ? (
					<div style={{ color: '#999', fontSize: 12 }}>{disabledMessage}</div>
				) : (
					<>
						<Checkbox.Group
							value={value}
							onChange={(vals) => onChange(vals as string[])}
							style={{
								display: 'flex',
								flexDirection: 'column',
								flexWrap: 'nowrap',
								gap: 4,
								maxHeight: 160,
								overflowY: 'auto',
								width: '100%',
							}}
						>
							{filteredOptions.map((opt) => (
								<div key={opt.value} style={{ width: '100%', flexShrink: 0 }}>
									<Checkbox value={opt.value} style={{ fontSize: 12 }}>
										{opt.label}
									</Checkbox>
								</div>
							))}
						</Checkbox.Group>
						{extraHeader}
					</>
				)}
			</div>
		);
	}

	return (
		<div>
			{searchable && (
				<div style={{ marginBottom: 12 }}>
					<Input
						placeholder={searchPlaceholder}
						value={search}
						onChange={(e) => setSearch(e.target.value)}
						allowClear
					/>
				</div>
			)}
			{disabled && disabledMessage ? (
				<div style={{ color: '#999', fontSize: 12 }}>{disabledMessage}</div>
			) : (
				<>
					<Checkbox.Group
						value={value}
						onChange={(vals) => onChange(vals as string[])}
						style={{
							display: 'flex',
							flexDirection: 'column',
							gap: 6,
						}}
					>
						{filteredOptions.map((opt) => (
							<Checkbox key={opt.value} value={opt.value}>
								{opt.label}
							</Checkbox>
						))}
					</Checkbox.Group>
					{extraHeader}
				</>
			)}
		</div>
	);
};
